module.exports = {
      id: "share-youtube-usage",
      viewBox: "0 0 44 45",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#share-youtube",
      toString: function () {
        return this.url;
      }
    }